<script>

import DataTable from '../components/DataTable'
import Vue from 'vue'
import { alert } from '../plugins/helpers'
import { Errors } from '../constantes'

export default {
  extends: DataTable,
  methods: {
    toggleAll () {
      if (this.selected.length) {
        this.selected = []
        this.allSelected = false
      } else {
        this.selected = this.items
        this.allSelected = true
      }
    },
    reload () {
      Vue.nextTick(() => {
        this.$http.cancel(this._uid)
        this.loading = true
        return this.$http.get(this.url, {
          requestId: this._uid,
          params: { ...this.params, id_unidade_negocio: this.id_unidade_negocio, pagination: this.pagination, filter: this.filter },
          options: { silent: true }
        }).then((res) => {
          this.items = res.data.items
          this.pagination.totalItems = res.data.total
        }).catch(() => {
          // cancel
        }).finally(() => {
          this.loading = false
          if (this.items.length <= 0 && this.filter.sla) {
            alert(Errors.no_situation_lead)
          }
        })
      })
    }
  }
}

</script>
